import NextSubsectionPanel from './NextSubsectionPanel';

export default NextSubsectionPanel;
